import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Cinema } from '../user-cinema/user-cinema.interface';
import { CinemaService } from './cinema.service';
const service = new CinemaService();

export interface CinemaState {
   cinemas: Array<Cinema>;
}

const CinemaStore: Module<CinemaState, StoreState> = {
   namespaced: true,
   state: {
      cinemas: [],
   },
   getters: {},
   mutations: {},
   actions: {
      async post(_context, cinema: Cinema) {
         const response = await service.post(cinema);
         return response;
      },
      async put(_context, cinema: Cinema) {
         const response = await service.put(cinema);
         return response;
      },
      async exists(context, id: number) {
         const response = await service.exists(id);
         return response;
      },
   },
};

export default CinemaStore;
